import { vnTemplate } from "./vnTemplate";
export class resultsInfo_template extends vnTemplate {
    getTemplateHtml() {
        return `
                <span><span data-bind="text: Number(nbr_results()).toLocaleString()"></span> result(s)</span>
                <span><span data-bind="text: Number(nbr_pages()).toLocaleString()"></span> pages</span>
                <span>Executed in <span data-bind="text: execution_time"></span> sec.</span>
            `;
    }
    getTemplateName() {
        return "resultsInfo-template";
    }
    getMainElementType() {
        return "caption";
    }
    getMainElementClasses() {
        return ["info-results"];
    }
    buildViewModel() {
        // define the viewmodel data/ functions
        return { nbr_results: ko.observable(""),
            nbr_pages: ko.observable(""),
            execution_time: ko.observable("")
        };
    }
    setExecutionTime(execTime) {
        this.viewModel[this.idElement].execution_time(execTime);
    }
    setNbResults(nbResults) {
        this.viewModel[this.idElement].nbr_results(nbResults);
    }
    setNbPages(nbPages) {
        this.viewModel[this.idElement].nbr_pages(nbPages);
    }
    setResults(results) {
        this.viewModel[this.idElement].nbr_results(results.nbr_results);
        this.viewModel[this.idElement].nbr_pages(results.nbr_pages);
        this.viewModel[this.idElement].execution_time(results.execution_time);
    }
}
